import type {
  CdaAutosignArgs,
  CdaAutosignService,
} from '../../application/cdaAutosignService/CdaAutosignService';

export class DevCdaAutosignService implements CdaAutosignService {
  warnModalText = `🖥 DEVELOPMENT ENVIRONMENT ONLY 🖥: CDA will get signed automatically when closing that modal.`;

  signCda = ({
    trialId,
    trialOpportunityId,
    siteId,
    cdaTemplateId,
    signatureId,
  }: CdaAutosignArgs) => {
    window.location.href = `//localhost:8000/hellosign/finalize_cda_signature?trialId=${trialId}&trialOpportunityId=${trialOpportunityId}&siteId=${siteId}&cdaTemplateId=${cdaTemplateId}&signatureId=${signatureId}`;
  };
}
